import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // Make sure this matches your app root

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    padding: '0',
    border: 'none',
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    background: '#fff',
    minWidth: '350px',
    maxWidth: '95vw',
    maxHeight: '95vh',
    overflow: 'auto',
    zIndex: 9999,
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.25)',
    zIndex: 9999,
  },
};

export default function GalleryModal({ isOpen, onRequestClose, children }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel='Edit Gallery Modal'
    >
      {children}
    </Modal>
  );
}
